import { KeySystemPasswordType, KeySystemRootKeyStorageMode } from '@standardnotes/models';
import { Result } from '@standardnotes/domain-core';
export class ChangeVaultKeyOptions {
    constructor(sync, _rotateVaultKey, _changeVaultStorageMode) {
        this.sync = sync;
        this._rotateVaultKey = _rotateVaultKey;
        this._changeVaultStorageMode = _changeVaultStorageMode;
    }
    async execute(dto) {
        let newStorageMode = dto.newStorageMode;
        let vault = dto.vault;
        if (dto.newPasswordOptions) {
            if (dto.newPasswordOptions.passwordType === KeySystemPasswordType.Randomized &&
                dto.newStorageMode &&
                dto.newStorageMode !== KeySystemRootKeyStorageMode.Synced) {
                return Result.fail('Cannot change storage mode to non-synced for randomized vault');
            }
            if (dto.newPasswordOptions.passwordType === KeySystemPasswordType.UserInputted &&
                !dto.newPasswordOptions.userInputtedPassword) {
                return Result.fail('User inputted password required');
            }
            const result = await this._rotateVaultKey.execute({
                vault: dto.vault,
                userInputtedPassword: dto.newPasswordOptions.passwordType === KeySystemPasswordType.UserInputted
                    ? dto.newPasswordOptions.userInputtedPassword
                    : undefined,
            });
            if (result.isFailed()) {
                return result;
            }
            vault = result.getValue();
            if (dto.newPasswordOptions.passwordType === KeySystemPasswordType.Randomized) {
                newStorageMode = KeySystemRootKeyStorageMode.Synced;
            }
        }
        if (newStorageMode && newStorageMode !== vault.keyStorageMode) {
            const result = await this._changeVaultStorageMode.execute({
                vault: vault,
                newStorageMode: newStorageMode,
            });
            if (result.isFailed()) {
                return result;
            }
        }
        await this.sync.sync();
        return Result.ok();
    }
}
